import { createTheme, lighten } from "@mui/material/styles";
import { ptBR } from "@mui/x-data-grid/locales";
import { darken } from "@mui/material/styles";

import { colors, themeLigth, themeDark } from "./colors";

const theme = (colorMode) =>
	createTheme(
		{
			palette: {
				mode: !colorMode ? "light" : "dark",
				colors: colors(),
				...(colorMode ? themeDark() : themeLigth()),
				dark: themeDark(),
				ligth: themeLigth(),
			},

			breakpoints: {
				values: {
					xs: 0,
					sm: 600,
					smx: 750,
					md: 900,
					lg: 1200,
					xl: 1536,
					xxl: 1830,
					mobile: 0,
					tablet: 640,
					laptop: 1024,
					desktop: 1200,
				},
			},

			components: {
				MuiPaper: {
					styleOverrides: {
						root: {
							backgroundColor: !colorMode
								? themeLigth().background.paper
								: themeDark().background.paper,
							background: !colorMode
								? themeLigth().background.paper
								: themeDark().background.paper,
						},
					},
				},
				MuiAutocomplete: {
					styleOverrides: {
						paper: {
							backgroundColor: !colorMode
								? darken(themeLigth().background.paper, 0.07)
								: lighten(themeDark().background.paper, 0.05),
							background: !colorMode
								? darken(themeLigth().background.paper, 0.07)
								: lighten(themeDark().background.paper, 0.05),
						},
					},
				},

				MuiFilledInput: {
					defaultProps: {
						sx: {
							borderRadius: "8px",
						},
						disableUnderline: true,
					},
				},

				MuiInputLabel: {
					styleOverrides: { shrink: { fontWeight: 600 } },
				},

				MuiLinearProgress: {
					styleOverrides: {
						root: {
							borderRadius: "4px",
							backgroundColor: !colorMode
								? themeLigth().loadingLinearProgress.main
								: themeDark().loadingLinearProgress.main,
						},
						bar: {
							borderRadius: "4px",
							backgroundColor: !colorMode
								? themeLigth().loadingLinearProgress.secondary
								: themeDark().loadingLinearProgress.secondary,
						},
					},
				},

				MuiButton: {
					styleOverrides: {
						root: {
							textTransform: "none",
						},
					},
				},
				MuiCssBaseline: {
					styleOverrides: {
						"@-moz-document url-prefix()": {
							"*": {
								scrollbarWidth: "auto",
								scrollbarColor: `${!colorMode
										? themeLigth().scrollBar.main
										: themeDark().scrollBar.main
									} transparent`,
							},
						},

						"::-webkit-scrollbar": {
							width: "8px",
							height: "8px",
						},
						"::-webkit-scrollbar-thumb": {
							backgroundColor: !colorMode
								? themeLigth().scrollBar.main
								: themeDark().scrollBar.main,

							borderRadius: "4px",
						},
						"::-webkit-scrollbar-track": {
							backgroundColor: !colorMode
								? themeLigth().scrollBar.secondary
								: themeDark().scrollBar.secondary,
							borderRadius: "4px",
						},
						"input.MuiInputBase-input:-webkit-autofill": {
							"-webkit-box-shadow": !colorMode
								? `0 0 0 100px ${themeLigth().hoverTextfieldDefault} inset`
								: `0 0 0 100px ${themeDark().hoverTextfieldDefault} inset`, // Remove o fundo azul
							"caret-color": "inherit", // Mantém a cor do cursor
							borderRadius: "8px",
						},
					},
				},
			},
			typography: {
				title: {
					fontSize: "24px",
					fontWeight: 900,
				},
				mySubtitle: {
					fontSize: "18px",
					fontWeight: 600,
				},
				mySubtitle2: {
					fontSize: "16px",
					fontWeight: 500,
				},
			},
		},
		ptBR
	);

export default theme;
